<template>
<!--Dialog-->
    <v-layout row justify-center v-if="($route.name == 'Banklist' && data.selectedBank) || ($route.name == 'Addbank' && data.bank)">

        <v-dialog v-model="dialog" persistent max-width="600px">

            <!-- Alert -->
            <Alert v-if="alertType !== ''" :atype="alertType" :message="alertMessage" :visibility="visibility" />

            <v-card class="semi-transparent-9-bg">

                <v-card-title v-if="$route.name == 'Banklist'" style="border-bottom: 5px solid #3944bb">

                    <img src="//assets.office4u.xyz/photos/BO-Demo/game-withdraw.svg" style="float: left; width: 15%; max-width: 50px; margin-right: 15px;"/>

                    <div class="withdraw-form-title">

                        <span>{{ $t( 'withdraw.title').toUpperCase() }}</span>

                    </div>

                </v-card-title>

                <v-card-title v-else style="border-bottom: 5px solid #3944bb">

                    <img src="//assets.office4u.xyz/photos/BO-Demo/blue-deposit-svg.svg" style="float: left; width: 15%; max-width: 50px; margin-right: 15px;"/>

                    <div class="withdraw-form-title">

                        <span>{{ $t( 'withdraw.enter_bank_detail').toUpperCase() }}</span>

                    </div>

                </v-card-title>

                <v-card-text class="v-card__text">

                    <span v-if="$route.name == 'Banklist'">{{ $t( 'deposit.min_amount_validation_rule', { amount: minWithdrawAmount , currency : this.$store.getters.currency } ) }}</span>

                    <div style="margin-bottom: 1em;"></div>

                    <!--possible to merge Withdraw form and Bank detail form-->
                    <!-- Withdraw Form-->
                    <v-form ref="withdrawFrom" v-model="valid" lazy-validation v-if="$route.name == 'Banklist'">

                        <!-- Product -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'reusable.product' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                <v-select :items="products" v-model="data.selectedProduct" item-value="id" :rules="productRules">

                                    <template slot="selection" slot-scope="data">

                                        <img :src="data.item.logo" width="45px;" style="margin-right: 5px;"/>

                                        {{ data.item.name }}

                                    </template>

                                    <template slot="item" slot-scope="data">

                                        <img :src="data.item.logo" width="45px;" style="margin-right: 5px;"/>

                                        {{ data.item.name }}

                                    </template>

                                </v-select>

                            </v-flex>

                        </v-layout>

                        <div style="margin-bottom: 1em;"></div>

                        <!-- Amount -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'history.amount' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                <v-text-field class="withdrawAmountField" @focus="inputFocus('withdrawAmountField')" v-model="data.amount" :rules="amountRules" single-line box required></v-text-field>

                            </v-flex>

                        </v-layout>

                        <div style="margin-bottom: 1em;"></div>

                        <!-- Bank name -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'withdraw.bank_name' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                <v-text-field :value="data.selectedBank.bank.name" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                        <div style="margin-bottom: 1em;"></div>

                        <!-- Bank Acc -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'withdraw.account_no' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                <v-text-field :value="data.selectedBank.bank_acc_no" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                        <div style="margin-bottom: 1em;"></div>

                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'withdraw.account_holder_name' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                <v-text-field :value="data.selectedBank.bank_acc_name" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                    </v-form>

                    <!-- Add Bank Detail Form-->
                    <v-form ref="bankDetailform" v-model="valid" lazy-validation v-else>

                        <!-- Bank Name -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'withdraw.bank_name' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                <v-text-field :value="data.bank.name" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                        <!-- Bank Acc -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{$t( 'withdraw.account_no' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                <v-text-field v-model="data.accNo" :rules="accNoRules" class="banklistAddAccNoField" @focus="inputFocus('banklistAddAccNoField')" required box single-line></v-text-field>

                            </v-flex>

                        </v-layout>

                        <!-- Acc Holder Name -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'withdraw.account_holder_name' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                <v-text-field :value="data.holderName" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                    </v-form>

                </v-card-text>

                <v-card-actions class="v-card__actions font-size">

                    <v-btn color="blue darken-1" :disabled="!valid" flat @click.prevent="save" small>{{ $t( 'shared.save' ) }}</v-btn>

                    <v-btn color="blue darken-1" flat @click.prevent="close" small>{{ $t( 'reusable.close' ) }}</v-btn>

                    <v-spacer></v-spacer>

                </v-card-actions>

            </v-card>

        </v-dialog>

    </v-layout>

</template>

<script>
import Api from "@/api";
import Alert from "@/components/Reusable/Alert.vue";

export default {
    name: "Dialog-Withdraw",
    props: [
        "status",

        // Withdraw Usage
        "productsList",
        "selectedBankAcc",
        "selectedProductId",

        // Add Bank Detail Usage
        "selectedBank"
    ],
    data() {
        return {
            valid: true,
            data: {
                // withdraw Form
                selectedBank: null,
                selectedProduct: null,
                amount: 0,
                method: 'Online',

                // new Bank Account Form
                bank: null,
                holderName: this.$store.getters.user_fullname,
                accNo: ''
            },
            products: [],
            minWithdrawAmount: 100,
            alertType: "",
            alertMessage: "",
            visibility: false,
        }
    },
    watch: {
        selectedBankAcc(newValue) {
            this.data.selectedBank = newValue;
        },
        productsList(newValue) {
            this.products = newValue;
        },
        selectedProductId(newValue) {
            this.data.selectedProduct = newValue;
        },
        selectedBank(newValue) {
            this.data.bank = newValue;
        }
    },
    components: {
        Alert
    },
    mounted() {
        this.getMinWithdraw();
    },
    computed: {
        dialog() {
            return this.status;
        },
        amountRules() {
            return [
                    v => !!v || this.$t( 'deposit.require_amount_validation_rule' ),
                    v => (v && v >= parseFloat(this.minWithdrawAmount)) || this.$t( 'deposit.min_amount_validation_rule', { amount: this.minWithdrawAmount , currency : this.$store.getters.currency} ),
            ]
         },
        productRules() {
            return [
                    v => !!v || this.$t( 'withdraw.product_validation_rule' )
            ]
        },
        accNoRules() {
            return [
                    v => !!v || this.$t( 'withdraw.account_no_validation_rule' )
            ]
        }
    },
    methods: {
        inputFocus(element) {

            let targetParentClass = null;

            targetParentClass = $('.' + element + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','0px 0px 2px #ccc');

            targetParentClass.css('box-shadow','0 0 2px #fff, 0 0 5px #fff, 0 0 10px #fff');

            targetParentClass.css('transition-delay','0.1s');
        },
        save() {

            if (this.$route.name == "Banklist") {

                this.withdraw();

            } else {

                this.addBankAcc();

            }

        },
        close() {

            this.dialog = !this.dialog;

            this.$emit("DialogClose", this.dialog);

        },
        showValidateMessage(message) {

            this.visibility = true;

            this.alertMessage = message;

            this.alertType = "error";

            let currentInstance = this;

            setTimeout(function() {

                currentInstance.visibility = false;

                currentInstance.alertMessage = "";

                currentInstance.alertType = "";

            } , 2000);

        },
        async withdraw() {

            if (this.data.selectedBank && this.data.selectedProduct && this.data.amount > 0) {

                let res = await Api.postWithdraw({
                    access_token: this.$store.getters.user_token,
                    product_from: this.data.selectedProduct,
                    member_bank_acc_id: this.data.selectedBank.id,
                    method: this.data.method,
                    amount: this.data.amount
                });

                if (res && 'success' in res && res.success === true) {

                    this.dialog = !this.dialog;

                    this.$emit("DialogSave", {
                        dialog: this.dialog,
                        message: res.message
                    });

                } else {

                    if(res.message == "token invalid") {

                        this.$store.dispatch('logout', res.data);

                        this.$router.push({name: 'login'})

                    } else if(res.message == "Ticket Detail Invalid") {

                        let message = res.message;

                        for (var oprop in res.data) {

                            message += '<br>' + res.data[oprop];

                        }

                        this.showValidateMessage(message);

                    } else if(res.data == "Product Username Not Exist. ") {

                        this.showValidateMessage(res.data);

                    } else {

                        this.showValidateMessage(res.message);

                    }

                }

            } else {

                this.showValidateMessage(this.$t( 'deposit.not_completed_form' ));

            }

        },
        async addBankAcc() {

            if (this.data.bank && this.data.accNo != "") {

                let res = await Api.postBankAccount({
                    access_token: this.$store.getters.user_token,
                    bank_id: this.data.bank.id,
                    bank_acc_no: this.data.accNo,
                });

                if (res && 'success' in res && res.success === true) {

                    this.dialog = !this.dialog;

                    this.$emit("DialogAddBankSave", {
                        dialog: this.dialog,
                        message: res.message
                    });

                } else {

                    if(res.message == "token invalid") {

                        this.$store.dispatch('logout', res.data);

                        this.$router.push({name: 'login'})

                    } else if(res.message == "Input Error") {

                        let message = res.message;

                        for (var oprop in res.data) {

                            message += '<br>' + res.data[oprop];

                        }

                        this.showValidateMessage(message);

                    } else {

                        this.showValidateMessage(res.message);

                    }

                }

            } else {

                this.showValidateMessage(this.$t( 'deposit.not_completed_form' ));

            }

        },
        async getMinWithdraw() {

            let res = await Api.getMinWithdraw();

            if(res){

                 this.minWithdrawAmount = res;

            }

        },

    }

}
</script>

<style scoped>

    .v-card__actions {
        padding-top: 2px;
    }

    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .font-size {
        font-size: 12px;
    }

    .withdraw-form-title{
    font-size: calc(1.0em + 1.5vmin);
    color: #3944bb;
    }

    .inputlabel {
        color: #4d4a4a;
        font-weight: bold;
    }
</style>
